module.exports = __webpack_public_path__ + "static/user1-d7f7e48cd82cdb16f954b2b1b80cfc74.png";